module.exports = __webpack_public_path__ + "static/media/logo.637af9ed.webp";